// 国密
const SM4 = require('gm-crypt').sm4
const sm4Config = {
  // encrypt/decypt main key; cannot be omitted
  key: 'qazplmh123456789',
  // optional; can be 'cbc' or 'ecb'
  mode: 'ecb', // default
  // optional; when use cbc mode, it's �necessary
  // iv: 'UISwD9fW6cFh9SNS', // default is null
  // optional: this is the cipher data's type; Can be 'base64' or 'text'
  cipherType: 'base64' // default is base64
}

const sm4 = new SM4(sm4Config)

/*
* 加密工具函数
* @param {String} text 待加密文本
*/
export function encrypt (plaintext) {
  return sm4.encrypt(plaintext)
}

/**
 * 解密工具函数
 * @param {String} text 待解密密文
 */
export function decrypt (text) {
  return sm4.decrypt(text)
}


